/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payors/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Payor from './Payor/index'
import React from 'react'
import Summary from './Summary/index'
import TysiaCollapsible from 'DesignSystem/TysiaCollapsible/index'
import TysiaCollapsibleCollapsed from 'DesignSystem/TysiaCollapsible/TysiaCollapsibleCollapsed/index'
import TysiaCollapsibleContent from 'DesignSystem/TysiaCollapsible/TysiaCollapsibleContent/index'
import TysiaCollapsibleHeader from 'DesignSystem/TysiaCollapsible/TysiaCollapsibleHeader/index'
import TysiaCollapsibleIcon from 'DesignSystem/TysiaCollapsible/TysiaCollapsibleIcon/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import Tysiav2Payor from 'DesignSystem/Svgs/Tysiav2Payor/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Payors({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let paymentPlanPayorsValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
path: 'payors',
})
  return (<React.Fragment
>
<TysiaCollapsible
  viewPath={`${viewPath}/TysiaCollapsible`}
>
{childProps => (
<React.Fragment>
<TysiaCollapsibleHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCollapsibleHeader`}
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 backgroundColor={dtColorsNeutral100}
 borderBottomStyle="solid"
 borderBottomWidth={1}
 borderBottomColor={dtColorsNeutral200}
 alignItems="center"
>
{childProps => (
<React.Fragment>
<Tysiav2Payor
{...childProps}
  viewPath={`${viewPath}/Tysiav2Payor`}
/>
<TysiaHeading
{...childProps}
  viewPath={`${viewPath}/TysiaHeading`}
 text="Payors"
 level="h4"
 marginTop={0}
 marginLeft={dtSpaceXs}
/>
<TysiaCollapsibleCollapsed
{...childProps}
  viewPath={`${viewPath}/TysiaCollapsibleCollapsed`}
>
{childProps => (
<Summary
{...childProps}
  viewPath={`${viewPath}/Summary`}
/>
)}
</TysiaCollapsibleCollapsed>
<TysiaCollapsibleIcon
{...childProps}
  viewPath={`${viewPath}/TysiaCollapsibleIcon`}
/>
</React.Fragment>
)}
</TysiaCollapsibleHeader>
<TysiaCollapsibleContent
{...childProps}
  viewPath={`${viewPath}/TysiaCollapsibleContent`}
>
{childProps => (
<div
  data-testid="Payors.List"
  data-view-path={viewPath}
 style={{'--pb-1-Z2g2GCs': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-2-Z2g2GCs': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-3-Z2g2GCs': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z2g2GCs': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(paymentPlanPayorsValueData) && paymentPlanPayorsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="payor"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Payor(${item?.id ?? item?._id ?? index})`}
      >
<Payor
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Payor(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
)}
</TysiaCollapsibleContent>
</React.Fragment>
)}
</TysiaCollapsible>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }